//
//
//
//
//
//
//

  export default {
      props:{
          config:{
              type:Object,
              default(){
                  return {
                      row:2,
                      column:[
                          {top:'5000+家',down:'地产客户',href:''},
                          {top:'90+家',down:'全国100强客户',href:''},
                          {top:'全国60%新房',down:'销售管理平台',href:''}
                      ]
                  }
              }
          }
      }
  }



// WEBPACK FOOTER //
// ./src/vue-components/column/column.vue